
import { Contractor } from "@/types/contractor";
import { useToast } from "@/hooks/use-toast";

interface FilteredContractorsProps {
  contractors: Contractor[];
  searchQuery: string;
}

// Fisher-Yates shuffle algorithm
const shuffleArray = <T,>(array: T[]): T[] => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

export const FilteredContractors = ({ contractors, searchQuery }: FilteredContractorsProps) => {
  // First filter contractors based on search criteria
  const filteredContractors = contractors.filter((contractor) => {
    const searchTerms = searchQuery.toLowerCase();
    return (
      contractor.name.toLowerCase().includes(searchTerms) ||
      contractor.service_type.toLowerCase().includes(searchTerms) ||
      contractor.location.toLowerCase().includes(searchTerms)
    );
  });

  // Separate featured and non-featured contractors
  const featuredContractors = filteredContractors.filter(c => c.featured);
  const nonFeaturedContractors = filteredContractors.filter(c => !c.featured);

  // Sort featured contractors by rating * review_count
  const sortedFeaturedContractors = featuredContractors.sort((a, b) => {
    // Prioritize Edmond Window Cleaning when both are featured
    if (a.name === 'Edmond Window Cleaning') return -1;
    if (b.name === 'Edmond Window Cleaning') return 1;
    
    return (b.rating * b.review_count) - (a.rating * a.review_count);
  });

  // Shuffle non-featured contractors
  const shuffledNonFeatured = shuffleArray(nonFeaturedContractors);

  // Combine the arrays: featured first, then shuffled non-featured
  return [...sortedFeaturedContractors, ...shuffledNonFeatured];
};
